import { useNavigate, useSearchParams } from "react-router-dom";
import { useMutation } from "convex/react";
import { api } from "../../../../convex/_generated/api";
import {
  subscribeToPush,
  serializeSubscription,
} from "../../lib/webPushRegistration";

export function OnboardingNotificationsPage() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const handle = searchParams.get("handle") ?? "";
  const registerPushToken = useMutation(api.pushTokens.registerPushToken);

  const handleEnable = async () => {
    if ("Notification" in window) {
      const permission = await Notification.requestPermission();
      if (permission === "granted") {
        try {
          const subscription = await subscribeToPush();
          if (subscription) {
            const tokenString = serializeSubscription(subscription);
            await registerPushToken({ token: tokenString, platform: "web" });
          }
        } catch {
          // Push subscription failed silently, user continues to paywall
        }
      }
    }
    navigate(
      `/onboarding/paywall?handle=${encodeURIComponent(handle)}`,
    );
  };

  const handleSkip = () => {
    navigate(
      `/onboarding/paywall?handle=${encodeURIComponent(handle)}`,
    );
  };

  return (
    <div
      style={{
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        background: "linear-gradient(180deg, #fdf2f2 0%, #ffffff 100%)",
        padding: "24px",
      }}
    >
      <div style={{ maxWidth: "360px", width: "100%", textAlign: "center" }}>
        {/* Mock notification preview */}
        <div
          style={{
            background: "white",
            borderRadius: "20px",
            padding: "16px",
            boxShadow: "0 8px 32px rgba(0,0,0,0.08)",
            marginBottom: "32px",
            border: "1px solid rgba(15, 23, 42, 0.06)",
          }}
        >
          <div style={{ display: "flex", alignItems: "center", gap: "8px", marginBottom: "12px" }}>
            <div
              style={{
                width: "28px",
                height: "28px",
                borderRadius: "8px",
                background: "#ff6b8a",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                color: "white",
                fontWeight: 800,
                fontSize: "0.75rem",
              }}
            >
              S
            </div>
            <span style={{ fontWeight: 700, fontSize: "0.8125rem", color: "#171717" }}>Stalkie</span>
            <span style={{ marginLeft: "auto", fontSize: "0.6875rem", color: "#a3a3a3" }}>now</span>
          </div>
          <div style={{ textAlign: "left" }}>
            <div style={{ fontWeight: 700, fontSize: "0.875rem", color: "#171717", marginBottom: "4px" }}>
              New follow detected
            </div>
            <div style={{ fontSize: "0.8125rem", color: "#525252" }}>
              @someone.new started following @{handle}
            </div>
          </div>
        </div>

        <div style={{ fontSize: "48px", marginBottom: "16px" }}>🔔</div>
        <h1 style={{ fontSize: "1.5rem", fontWeight: 800, color: "#171717", marginBottom: "8px" }}>
          Stay in the loop
        </h1>
        <p style={{ color: "#737373", marginBottom: "32px", fontSize: "0.9375rem", lineHeight: 1.5 }}>
          Get notified instantly when @{handle} follows or unfollows someone.
        </p>

        <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
          <button
            onClick={handleEnable}
            style={{
              width: "100%",
              padding: "16px",
              background: "var(--pink-primary, #ff6b8a)",
              color: "white",
              border: "none",
              borderRadius: "16px",
              fontWeight: 800,
              fontSize: "1.0625rem",
              cursor: "pointer",
              boxShadow: "0 4px 16px rgba(255, 107, 138, 0.3)",
            }}
          >
            Enable Notifications
          </button>
          <button
            onClick={handleSkip}
            style={{
              width: "100%",
              padding: "16px",
              background: "transparent",
              color: "#737373",
              border: "none",
              borderRadius: "16px",
              fontWeight: 600,
              fontSize: "1rem",
              cursor: "pointer",
            }}
          >
            Not now
          </button>
        </div>
      </div>
    </div>
  );
}
